<template>
  <el-dialog
    v-model="userStore.showLoginDialog"
    top="10vh"
    width="1000px"
    class="login-dialog"
    :show-close="false"
    :append-to-body="true"
    @close="$emit('close')"
  >
    <div class="login-box">
      <div class="login-cover">
        <img class="background" src="/src/assets/images/login-cover.png" alt="login-cover" />
        <div class="front">
          <img class="logo" src="/src/assets/images/logo.png" alt="logo" />
          <!-- <h2 class="cover-title">标题文案填充标题文案填充标题文案填充标题文案填充</h2>
          <p class="cover-introduction">
            <img
              class="checked-icon"
              src="/src/assets/images/icon/checked.png"
              alt="checked"
            />描述文案1
          </p>
          <p class="cover-introduction">
            <img
              class="checked-icon"
              src="/src/assets/images/icon/checked.png"
              alt="checked"
            />描述文案2
          </p>
          <p class="cover-introduction">
            <img
              class="checked-icon"
              src="/src/assets/images/icon/checked.png"
              alt="checked"
            />描述文案3
          </p> -->
        </div>
      </div>
      <div class="login-form">
        <el-icon class="close-icon" size="28px" @click="closeDialog"><Close /></el-icon>
        <h1 class="welcome-title">欢迎登录</h1>
        <p class="welcome-introduction">
          AI设计 · 创作更高效
        </p>
        <el-form :model="loginForm" label-width="auto">
          <el-form-item>
            <el-input v-model="loginForm.userName" placeholder="请输入您的账号">
              <template #prefix>
                <img src="/src/assets/images/icon/username.png" style="width: 18px" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="loginForm.passWord"
              type="password"
              show-password
              placeholder="请输入密码"
            >
              <template #prefix>
                <img src="/src/assets/images/icon/password.png" style="width: 18px" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="loginForm.randomCode" placeholder="请输入验证码">
              <template #prefix>
                <img src="/src/assets/images/icon/captcha.png" style="width: 18px" />
              </template>
              <template #suffix>
                <img class="captcha-code" :src="fullCaptchaCodeUrl" @click="refreshCaptchaCode" />
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="footer-bar">
          <div class="forget"><el-link href="https://www.ca9.cn/index/license" style="float: left;" target="_blank">免费注册</el-link><el-link href="/forgot">忘记密码？</el-link></div>
          <el-button style="width: 100%" @click="checkLogin" :loading="btnLock">登录</el-button>
          <div class="aggress">
            <el-checkbox v-model="aggress" style="margin-right: 4px" />同意并<el-link
              @click="agreePolicy"
              >阅读用户协议</el-link
            >
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import * as LoginApi from '@/api/login.ts'
import { ref, reactive, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useUserStore } from '@/store/user.ts'
import Config from '@/utils/config.ts'
const userStore = useUserStore()

const closeDialog = () => {
  userStore.closeLoginDialog()
}
const refreshCaptchaCode = () => {
  loginForm.randomKey = new Date().getTime() + ''
}
const fullCaptchaCodeUrl = computed(() => {
  return location.protocol + '//' + location.host + '/api/randomCode?t=' + loginForm.randomKey
})

const loginForm = reactive({
  userName: null,
  passWord: null,
  randomCode: null,
  type: 1,
  randomKey: null
})
refreshCaptchaCode()

const btnLock = ref(false)
const aggress = ref<boolean>(true)
const checkLogin = () => {
  if (!loginForm.userName) {
    ElMessage.error('请输入您的账号')
    return false
  }
  if (!loginForm.passWord) {
    ElMessage.error('请输入密码')
    return false
  }
  if (!loginForm.randomCode) {
    ElMessage.error('请输入验证码')
    return false
  }
  if (aggress.value) {
    submitLogin()
  } else {
    ElMessageBox.confirm('已阅读并同意用户协议', '友情提示', {
      confirmButtonText: '同意并继续',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      aggress.value = true
      submitLogin()
    })
  }
}
const agreePolicy = () => {
  aggress.value = true
  window.open('/policy', '_blank')
}
const submitLogin = () => {
  btnLock.value = true
  LoginApi.login({
    ...loginForm
  })
    .then(res => {
      btnLock.value = false
      ElMessage.success('登录成功')
      userStore.setToken(res.data.token)
      let userInfo = {}
      Object.keys(res.data).forEach(key => {
        if (res.data[key]) {
          userInfo[key] = res.data[key]
        }
      })
      userStore.setUserInfo(userInfo)
      setTimeout(() => {
        closeDialog()
        window.location.reload()
      }, 1000)
    })
    .catch(() => {
      btnLock.value = false
    })
}
</script>

<style lang="scss" scoped>
.login-box {
  display: flex;
  border-radius: 10px;
  .login-cover {
    width: 402px;
    height: 687px;
    position: relative;
    .background {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .front {
      padding: 30px;
      position: relative;
      .logo {
        width: 205px;
        height: 59px;
      }
      .cover-title {
        font-size: 26px;
        margin: 40px 0;
      }
      .cover-introduction {
        font-size: 16px;
        margin-top: 20px;
        display: flex;
        align-items: center;
        .checked-icon {
          width: 22px;
          height: 22px;
          margin-right: 10px;
        }
      }
    }
  }
  .login-form {
    flex: 1;
    padding: 0 80px;
    position: relative;
    .close-icon {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
    .welcome-title {
      font-size: 26px;
      margin-top: 60px;
      text-align: center;
    }
    .welcome-introduction {
      font-size: 16px;
      margin: 20px 0;
      text-align: center;
    }
    :deep(.el-input) {
      .el-input__wrapper {
        background: #f1f4f5;
        box-shadow: none;
        padding: 10px 15px;
        font-size: 18px;
        .el-input__inner {
          margin-left: 10px;
        }
      }
    }
  }
  .captcha-code {
    cursor: pointer;
    width: 120px;
    height: 35px;
  }
  .footer-bar {
    :deep(.el-button) {
      height: 50px;
      border: none;
      background: linear-gradient(to right, #ffdcf8, #ffe9d7);
      transition: 0.3s;
      font-size: 18px;
      &:hover {
        opacity: 0.8;
      }
    }
    .forget {
      text-align: right;
      cursor: pointer;
      margin-bottom: 20px;
    }
    .aggress {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
    }
  }
}
</style>
